/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import Footer from '../Common/Footer';
import { BiEdit } from 'react-icons/bi';
import { FaPlus, FaChevronDown } from 'react-icons/fa6';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoSearch } from 'react-icons/io5';
import Loading from '../Common/Loading';
import { useDispatch } from 'react-redux';
import { deleteTasks, getAllTasks, getMarkAsTasks, getTaskByID } from '../../Redux/TaskSlice';
import { formatDate } from '../Common/Common';
import AddTasks from './AddTasks';
import { MdDeleteForever } from 'react-icons/md';
import sweetAlert from '../Common/sweetAlert';
import Pagination from '../Common/Pagination';

export default function ProjectTask({ isVisible,
    setIsVisible,
    setSidebarOpen,
    sidebarOpen,
    isDark,
    setIsDark, }) {
    const dispatch = useDispatch()
    const [loading, setloading] = useState(true);
    const [OpenModel, setOpenModel] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [Task, setTask] = useState([]);
    const [loadFrist, setloadFrist] = useState(true);
    const [EditTask, setEditTask] = useState([]);
    const [activeTab, setActiveTab] = useState('all');
    const [Type, setType] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortedField, setSortedField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    useEffect(() => {
        if (loadFrist) {
            fetchData();
            const timer = setTimeout(() => {
                setloading(false)
                setloadFrist(false);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [loadFrist]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const toggle = () => {
        setOpenModel(!OpenModel)
        setEditTask([])
    }

    const fetchData = async () => {
        try {
            setloading(true)
            const response = await dispatch(getAllTasks({ MarkAsDone: Type }))
            if (response?.payload?.status === true) {
                setTask(response?.payload?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleTabClick = (tab) => {
        if (tab === 'todo') {
            setType(false);
        } else if (tab === 'done') {
            setType(true);
        } else {
            setType(false);
        }
        setActiveTab(tab);
        setSearchTerm('');
        setloadFrist(true);
    };

    const filtereTask = Task.filter((item) => {
        const matchSearch = item?.projectName && item?.projectName.toLowerCase().includes(searchTerm.toLowerCase());
        if (activeTab === 'done') return matchSearch && item?.markAsDone === true;
        if (activeTab === 'todo') return matchSearch && !item?.markAsDone;
        if (activeTab === 'overdue') return matchSearch && item?.dueDate && new Date(item.dueDate) < new Date() && !item?.markAsDone;
        return matchSearch;
    });

    const handleSort = (field) => {
        if (sortedField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortOrder("asc");
            setSortedField(field);
        }
    };

    const sortData = (data, field, order) => {
        const sortedData = [...data];
        sortedData.sort((a, b) => {
            const aTrimmed = a[field]?.trim() || '';
            const bTrimmed = b[field]?.trim() || '';
            if (order === "asc") {
                return aTrimmed?.localeCompare(bTrimmed);
            }
        });
        return sortedData;
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = sortData(filtereTask, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow)
    const totalPages = Math.ceil(filtereTask.length / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const TaskEdit = (id) => {
        try {
            dispatch(getTaskByID(id)).then((res) => {
                if (res.payload.status === true) {
                    setEditTask(res.payload.data);
                }
            })
        } catch (error) {
            console.log('error :>> ', error);
        }
    }

    const handleDeleteProjectTask = async (id) => {
        try {
            const result = await sweetAlert.confirm("Are you sure?", "You won't be able to revert this!");
            if (result.isConfirmed) {
                await dispatch(deleteTasks(id)).then((res) => {
                    if (res.payload.status === true) {
                        setloadFrist(true);
                        setCurrentPage(1)
                    }
                });
                sweetAlert.success("Deleted successfully");
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    };

    // Stat counts
    const totalTasks = Task.length;
    const completedTasks = Task.filter(t => t?.markAsDone === true).length;
    const inProgressTasks = Task.filter(t => !t?.markAsDone && t?.dueDate && new Date(t.dueDate) >= new Date()).length;
    const pendingTasks = Task.filter(t => !t?.markAsDone).length;
    const overdueTasks = Task.filter(t => t?.dueDate && new Date(t.dueDate) < new Date() && !t?.markAsDone).length;

    // Priority based on due date
    const getPriorityBadge = (item) => {
        if (!item?.dueDate) return <span className="crm-priority"><span className="crm-dot crm-dot-low"></span>Low</span>;
        const daysLeft = Math.ceil((new Date(item.dueDate) - new Date()) / (1000 * 60 * 60 * 24));
        if (daysLeft < 0) return <span className="crm-priority"><span className="crm-dot crm-dot-high"></span>High</span>;
        if (daysLeft < 3) return <span className="crm-priority"><span className="crm-dot crm-dot-medium"></span>Medium</span>;
        return <span className="crm-priority"><span className="crm-dot crm-dot-low"></span>Low</span>;
    };

    // Simulated tag based on phase
    const getTaskTag = (item, index) => {
        const tagOptions = [
            ['crm-tag crm-tag-frontend', 'Frontend'],
            ['crm-tag crm-tag-backend', 'Backend'],
            ['crm-tag crm-tag-design', 'UI/UX'],
            ['crm-tag crm-tag-bug', 'Bug'],
            ['crm-tag crm-tag-testing', 'Testing'],
            ['crm-tag crm-tag-docs', 'Docs'],
        ];
        const tag = tagOptions[index % tagOptions.length];
        return <span className={tag[0]}>{tag[1]}</span>;
    };

    const tabs = [
        { id: 'all', label: `All Tasks (${totalTasks})` },
        { id: 'todo', label: `To-Do (${pendingTasks})` },
        { id: 'done', label: `Completed (${completedTasks})` },
        { id: 'overdue', label: `Overdue (${overdueTasks})` },
    ];

    return (
        <div>
            <div className="flex flex-1">
                <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

                    {/* Page Header */}
                    <div className="crm-page-header">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="crm-page-title">Tasks</h1>
                                <ol className="crm-breadcrumb">
                                    <li><a href="/Analytics">Disploy</a></li>
                                    <li>/</li>
                                    <li>Projects</li>
                                    <li>/</li>
                                    <li className="active">Tasks</li>
                                </ol>
                            </div>
                            <button className="crm-new-btn" onClick={() => setOpenModel(true)}>
                                <FaPlus size={11} />
                                New Task
                            </button>
                        </div>
                    </div>

                    <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                        {/* Stat Cards */}
                        <div className="crm-stats-row">
                            <div className="crm-stat-card crm-card-indigo">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-indigo">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Total Tasks</p>
                                        <p className="stat-value">{totalTasks}</p>
                                        {/* <p className="stat-trend-up">↑ 18% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-green">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-green">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Completed</p>
                                        <p className="stat-value">{completedTasks}</p>
                                        {/* <p className="stat-trend-up">↑ 25% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-blue">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-blue">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">In Progress</p>
                                        <p className="stat-value">{inProgressTasks}</p>
                                        {/* <p className="stat-trend-up">↑ 12% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-orange">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-orange">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Pending</p>
                                        <p className="stat-value">{pendingTasks}</p>
                                        {/* <p className="stat-trend-down">↓ 8% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-red">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-red">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Overdue</p>
                                        <p className="stat-value">{overdueTasks}</p>
                                        {/* <p className="stat-trend-down">↓ 5% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Main Panel */}
                        <div className="crm-panel">
                            {/* Tab Navigation */}
                            <div className="flex items-center justify-between px-4 pt-2 border-b border-gray-100">
                                <div className="crm-tabs" style={{ borderBottom: 'none' }}>
                                    {tabs.map(t => (
                                        <button key={t.id} className={`crm-tab-btn${activeTab === t.id ? ' active' : ''}`}
                                            onClick={() => handleTabClick(t.id)}>
                                            {t.label}
                                        </button>
                                    ))}
                                </div>
                                <div className="ml-auto crm-search-box">
                                    <IoSearch size={14} />
                                    <input
                                        type="text"
                                        placeholder="Search tasks..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            {loading && (
                                <div className="flex justify-center items-center h-64">
                                    <Loading />
                                </div>
                            )}

                            {!loading && (
                                <>
                                    <div className="crm-table-wrapper" style={{ border: 'none', borderRadius: 0 }}>
                                        <table className="crm-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 40 }}>Done</th>
                                                    <th onClick={() => handleSort("taskName")} className="cursor-pointer">
                                                        Task <span className="text-gray-300 ml-1">↕</span>
                                                    </th>
                                                    <th onClick={() => handleSort("projectName")} className="cursor-pointer">
                                                        Project <span className="text-gray-300 ml-1">↕</span>
                                                    </th>
                                                    <th>Assignee</th>
                                                    <th className="center">Status</th>
                                                    <th className="center">Priority</th>
                                                    <th>Due Date</th>
                                                    <th>Phase</th>
                                                    <th>Tags</th>
                                                    <th className="center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentRows && currentRows?.length > 0 ? (
                                                    currentRows?.map((item, index, arr) => {
                                                        const isOverdue = item?.dueDate && new Date(item.dueDate) < new Date() && !item?.markAsDone;
                                                        const showUpward = index >= arr.length - 2 && arr.length > 1;
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <label className="flex items-center justify-center cursor-pointer">
                                                                        <div className="relative group">
                                                                            <input
                                                                                checked={item?.markAsDone}
                                                                                type="radio"
                                                                                className="accent-indigo-600"
                                                                                onClick={() => {
                                                                                    const payload = {
                                                                                        TaskID: item.taskID,
                                                                                        MarkAsDone: item?.markAsDone === true ? false : true,
                                                                                    };
                                                                                    dispatch(getMarkAsTasks(payload)).then((res) => {
                                                                                        if (res.payload.status === true) {
                                                                                            setloadFrist(true);
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            />
                                                                            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 hidden group-hover:flex flex-col items-center">
                                                                                <span className="bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap">
                                                                                    {item?.markAsDone ? "Mark To-Do" : "Mark Done"}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        className={`text-sm font-medium cursor-pointer ${item?.markAsDone ? 'line-through text-gray-400' : 'text-gray-800'}`}
                                                                        onClick={() => { setOpenModel(true); TaskEdit(item.taskID); }}>
                                                                        {item?.taskName}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-sm text-gray-600">{item?.projectName || '—'}</span>
                                                                </td>
                                                                <td>
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold">
                                                                            {(item?.assigneeName || 'D').charAt(0).toUpperCase()}
                                                                        </div>
                                                                        <span className="text-sm text-gray-600">{item?.assigneeName || 'Dhruv'}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="center">
                                                                    {item?.markAsDone
                                                                        ? <span className="crm-badge crm-badge-completed">Completed</span>
                                                                        : isOverdue
                                                                            ? <span className="crm-badge crm-badge-overdue">Overdue</span>
                                                                            : <span className="crm-badge crm-badge-inprogress">In Progress</span>
                                                                    }
                                                                </td>
                                                                <td className="center">{getPriorityBadge(item)}</td>
                                                                <td>
                                                                    <span className={`text-sm ${isOverdue ? 'crm-date-overdue' : item?.markAsDone ? 'text-gray-400 line-through' : 'text-gray-600'}`}>
                                                                        {formatDate(item?.dueDate) || '—'}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-sm text-gray-500">{item?.phase || 'General'}</span>
                                                                </td>
                                                                <td>
                                                                    {getTaskTag(item, index)}
                                                                </td>
                                                                <td className="center">
                                                                    <div className="relative inline-block text-left">
                                                                        <button
                                                                            className="crm-action-btn p-1.5 hover:bg-slate-100 rounded-md transition-colors text-slate-500 hover:text-slate-800"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenActionMenuId(openActionMenuId === item.taskID ? null : item.taskID);
                                                                            }}
                                                                        >
                                                                            <BsThreeDotsVertical size={14} />
                                                                        </button>

                                                                         {openActionMenuId === item.taskID && (
                                                                             <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 text-left flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setOpenModel(true);
                                                                                        TaskEdit(item?.taskID);
                                                                                        setOpenActionMenuId(null);
                                                                                    }}
                                                                                    className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                >
                                                                                    <BiEdit size={14} className="text-indigo-500" />
                                                                                    <span>Edit Task</span>
                                                                                </button>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleDeleteProjectTask(item?.taskID);
                                                                                        setOpenActionMenuId(null);
                                                                                    }}
                                                                                    className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 transition-colors text-left"
                                                                                >
                                                                                    <MdDeleteForever size={14} className="text-red-500" />
                                                                                    <span>Delete</span>
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center py-12 text-gray-400">
                                                            <div className="flex flex-col items-center gap-2">
                                                                <svg width="40" height="40" fill="none" stroke="#d1d5db" strokeWidth="1.5" viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
                                                                <p className="font-medium">No tasks found</p>
                                                                <p className="text-sm">Create your first task to get started</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination setCurrentPage={setCurrentPage} name='Tasks' handlePageChange={handlePageChange}
                                        currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages}
                                        length={currentRows?.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {OpenModel && (
                <AddTasks toggle={toggle} setloadFrist={setloadFrist} EditTask={EditTask} identityName='Project' />
            )}
        </div>
    )
}
